<div *ngIf="interrupted">
  <div class="interruption">Interrupted</div>
</div>
